import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class DropdownAmenities extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            disabled: this.props.disabled,
            error: this.props.error,
            placeholder: this.props.placeholder
        };
    };

    componentWillMount() {};

    componentDidMount(){}

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            options: nextProps.options,
            disabled: nextProps.disabled,
            error: nextProps.error,
            placeholder: nextProps.placeholder
        });
    }

    functions = {
        select: (id, option) => {
            for(let i = 0; i < this.state.options.length; i++){
                if(id === this.state.options[i].id){
                    this.state.options[i].selected = option;
                }
            }
            this.props.onChange(this.state.options);
        }
    };

    sort = {
        amenities: (items) => {
            try {
                let array = [];
                for (let key in items) {
                    array.push(items[key]);
                }
                array.sort(function (a, b) {
                    var at = a.title,
                        bt = b.title;
                    return at > bt ? 1 : (at < bt ? -1 : 0);
                });
                return array
            } catch (e) {}
        }
    };

    renders = {
        value: (value) => {
            try {
                return JSON.parse(value).title;
            }catch (e) {}
        }
    };

    render() {
        return (
            <div className={Styles.amenitiesContainerInner}>
                {
                    this.sort.amenities(this.state.options).map((item, i) => {
                        return (
                            <div key={i} className={Styles.amenitiesContainerItem}>
                                {
                                    !item.selected &&
                                    <img onClick={() => this.functions.select(item.id, true)}
                                         src={require("../../assets/images/checkmark_new.svg")}
                                         className={Styles.amenitiesContainerItemIcon}/>
                                }
                                {
                                    item.selected && salesChannelRegister.get("name") === "propertybooster" &&
                                    <img onClick={() => this.functions.select(item.id, false)}
                                         src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                         className={Styles.amenitiesContainerItemIcon}/>
                                }
                                {
                                    item.selected && salesChannelRegister.get("name") === "boostabostad" &&
                                    <img onClick={() => this.functions.select(item.id, false)}
                                         src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                         className={Styles.amenitiesContainerItemIcon}/>
                                }
                                {
                                    item.selected && salesChannelRegister.get("name") === "yieldlock" &&
                                    <img onClick={() => this.functions.select(item.id, false)}
                                         src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                         className={Styles.amenitiesContainerItemIcon}/>
                                }
                                <div onClick={() => {
                                    if (item.selected) {
                                        this.functions.select(item.id, false)
                                    } else {
                                        this.functions.select(item.id, true)
                                    }
                                }} style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={Styles.amenitiesContainerItemText}>
                                    {item.title}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

export default DropdownAmenities;


// WEBPACK FOOTER //
// ./src/components/dropdown-amenities/component.js